import { Task } from 'src/core/master-data/domain/task';
import { StopTaskQueueElement } from 'src/core/queue/domain/elements/stop-task-queue-element';
import { Nullable } from 'src/core/common/domain/types/types';

export class StopTaskRequest {
  constructor(public readonly task: Task, public readonly queueElement: Nullable<StopTaskQueueElement>) {}

  static fromTask(task: Task) {
    return new this(task, null);
  }

  static retry(element: StopTaskQueueElement) {
    return new this(element.task, element);
  }
}
